









import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ExifTable extends Vue {
  @Prop({ required: true }) private readonly data!: any;

  get exifTable(): object | null {
    function formatTime(time: number) {
      if (time < 1.0 / 10_000) {
        time *= 1_000_000;
        return time.toFixed(2) + " µs";
      } else if (time < 1.0 / 10) {
        time *= 1_000;
        return time.toFixed(2) + " ms";
      } else {
        return time.toFixed(2) + " s";
      }
    }

    if (this.data === null) {
      return null;
    }

    return {
      fields: [
        {
          key: "tag",
          sortable: true,
          label: "Eigenschaft",
        },
        {
          key: "value",
          sortable: false,
          label: "Wert",
        },
      ],
      items: [
        { tag: "Hersteller", value: this.data.Make },
        { tag: "Model", value: this.data.Model },
        { tag: "Belichtungszeit", value: formatTime(this.data.ExposureTime) },
        { tag: "ISO", value: this.data.ISOSpeedRatings },
        { tag: "Brennweite", value: this.data.FocalLength.toFixed(0) + " mm" },
        { tag: "Blendenzahl", value: "F/" + this.data.FNumber.toFixed(0) },
      ],
    };
  }
}
